import { api } from "@/service";
import type { TEmi, TReverseEmi } from "@/types";
import { AxiosError } from "axios";

type GetQueryParams = {
   page?: number;
   limit?: number;
   status?: "SCHEDULED" | "COLLECTED";
   createdBy?: string;
   start?: string;
   end?: string;
};
export class EMIService {
   async payEMI(slug: string, id: number, fine: number | undefined) {
      return api
         .patch<TEmi>(`/workspaces/${slug}/emis/${id}`, { fine })
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
   async getEmis(slug: string, query?: GetQueryParams) {
      return api
         .get<(TEmi & { userId: string })[]>(`/workspaces/${slug}/emis`, {
            params: query,
         })
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }

   async postEmis(
      slug: string,
      payload: Pick<TEmi, "amount" | "applicationId">,
   ) {
      return api
         .post<TEmi & { userId: string }>(`/workspaces/${slug}/emis`, payload)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }

   async undoEMI(slug: string, id: number) {
      return api
         .patch<TReverseEmi>(`/workspaces/${slug}/emis/${id}/undo`)
         .then((response) => response.data)
         .catch((error: AxiosError) => {
            throw error.response?.data;
         });
   }
}
